import { useEffect } from "react";
import TagManager from "react-gtm-module";

const GTM_ID = process.env.GOOGLE_TAG_MANAGER_ID || "GTM-T38KKSF3";

const GTMProvider = ({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        if (GTM_ID) {
            TagManager.initialize({ gtmId: GTM_ID });
        }
    }, []);

    return children;
};

export default GTMProvider;
